import keycloak from './keycloak';

export const authenticatedFetch = async (url, options = {}) => {
    try {
        await keycloak.updateToken(30);
    } catch (error) {
        keycloak.login();
        throw new Error('Token refresh failed');
    }

    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
        Authorization: `Bearer ${keycloak.token}`,
    };

    const response = await fetch(url, {
        ...options,
        headers,
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    return response;
};
